import React, { useContext } from 'react';
import { CButton } from '@coreui/react-pro';
import { toast } from 'react-toastify';

import { numberWithCommas, tryParseJSON } from '../../../../../../utils';
import { TrainingProductCardContext } from './TrainingProductCard';
import { useSelector } from 'react-redux';

const SelectTrainingTier = ({ productSelected }) => {
     const { setTierId, listProductCart, listProducts, product, setListProductCart, setProduct, setListProducts } =
          useContext(TrainingProductCardContext);

     const pricingTiers = tryParseJSON(productSelected?.pricingTiers) || [];
     const pricingTiersFilter = pricingTiers?.filter(
          (tier) => tier.name && (tier.stripeProductID || tier.stripeTestProductID) && tier.price && tier.seats
     );

     const cartItems = useSelector((state) => state.subscriber.cart.items);

     const preventPurchaseText = productSelected.preventPurchase ? productSelected.preventPurchaseText || 'This product is not available now' : null;

     const reduceSeat = (productSeat, tierSelected) => {
          const tierQuantity = parseInt(tierSelected.quantity);
          const newListTierSelected = [...productSeat.listTierSelected];
          const newTierSelected = { ...tierSelected, quantity: tierSelected.quantity - 1 };
          const indexTier = productSeat.listTierSelected.findIndex((item) => item.id === tierSelected.id);
          newListTierSelected[indexTier] = newTierSelected;

          const newProduct = {
               ...productSeat,
               selected: productSelected.selected,
               listTierSelected: newListTierSelected,
          };
          if (tierQuantity > productSeat.organizationMin) {
               const indexProduct = listProductCart.findIndex((item) => item.id === newProduct.id);

               const newListProductCart = [...listProductCart];
               newListProductCart[indexProduct] = newProduct;

               setListProductCart(newListProductCart);
               if (productSeat.id === product.id) {
                    setProduct(newProduct);
               }

               const indexListProduct = listProducts.findIndex((item) => item.id === newProduct.id);
               const newProducts = [...listProducts];
               newProducts[indexListProduct] = newProduct;
               setListProducts(newProducts);
          } else {
               setTierId(newProduct, tierSelected);
          }
     };

     const increaseSeat = (productSeat, tierSelected) => {
          const quantityCartItem = cartItems?.find((item) => item.tierId === tierSelected.id)?.quantity;
          const tierQuantity = parseInt(tierSelected.quantity);
          const newTierQuantity = tierQuantity + 1;
          const comparisonQuantity = quantityCartItem + newTierQuantity > productSeat.organizationMax;
          const conditionPurchaseSeat = productSelected.organizationMax === -1 ? false : comparisonQuantity;
          if (quantityCartItem && conditionPurchaseSeat) {
               toast.error('Maximum seat purchase has been exceeded is ' + productSeat.organizationMax);
               return;
          } else {
               if (tierQuantity < productSeat.organizationMax || productSeat.value === 'custom' || productSeat.organizationMax === -1) {
                    const newTierSelected = { ...tierSelected, quantity: tierSelected.quantity + 1 };
                    const newListTierSelected = [...productSeat.listTierSelected];

                    const indexTier = productSeat.listTierSelected.findIndex((item) => item.id === tierSelected.id);
                    newListTierSelected[indexTier] = newTierSelected;

                    const newProduct = {
                         ...productSeat,
                         selected: productSelected.selected,
                         listTierSelected: newListTierSelected,
                    };

                    const indexProduct = listProductCart.findIndex((item) => item.id === newProduct.id);
                    const newListProductCart = [...listProductCart];
                    newListProductCart[indexProduct] = newProduct;

                    setListProductCart(newListProductCart);
                    if (newProduct.id === product.id) {
                         setProduct(newProduct);
                    }

                    const indexListProduct = listProducts.findIndex((item) => item.id === newProduct.id);
                    const newProducts = [...listProducts];
                    newProducts[indexListProduct] = newProduct;
                    setListProducts(newProducts);
               }
               if (tierQuantity === productSeat.organizationMax) {
                    toast.error('Maximum seat purchase is ' + productSeat.organizationMax);
                    return;
               }
          }
     };

     if (!pricingTiersFilter?.length) {
          return null;
     }

     const onSelectTeam = (productSelected, tier) => {
          const quantityCartItem = cartItems?.find((item) => item.tierId === tier.id)?.quantity;
          const conditionSelectTier = productSelected.organizationMax === -1 ? false : quantityCartItem >= productSelected.organizationMax;
          const quantityExceedsMax =
               productSelected.organizationMax === -1 ? false : quantityCartItem + productSelected.organizationMin > productSelected.organizationMax;

          if (conditionSelectTier || quantityExceedsMax) {
               toast.error('Maximum seat purchase has been exceeded is ' + productSelected.organizationMax);
               return;
          } else {
               setTierId(productSelected, tier);
          }
     };

     return (
          <div className="mb-3 mt-3 select-training-tier">
               <p className="mb-2 mt-3">
                    <strong>Purchase large group trainings at a discount</strong>
               </p>
               <p className="d-block mb-3 mt-1" style={{ fontSize: '15px' }}>
                    We will contact you to schedule a custom training date. During checkout, you may choose the option to receive an invoice and pay
                    later.
               </p>
               {pricingTiersFilter.map((tier) => {
                    const tierSelected = productSelected.listTierSelected?.find((tierSelected) => tierSelected.id === tier.id);

                    return (
                         <div key={tier.id} className="select-training-product select-training-tier price-training-product mb-2">
                              {tierSelected ? (
                                   <div className="change-quantity">
                                        <span
                                             className="btn btn-select-quantity"
                                             onClick={() =>
                                                  reduceSeat(
                                                       listProductCart.find((item) => item.id === productSelected.id),
                                                       tierSelected
                                                  )
                                             }
                                        >
                                             -
                                        </span>
                                        <span className="quantity">{tierSelected.quantity}</span>
                                        <span
                                             className="btn btn-select-quantity"
                                             onClick={() =>
                                                  increaseSeat(
                                                       listProductCart.find((item) => item.id === productSelected.id),
                                                       tierSelected
                                                  )
                                             }
                                        >
                                             +
                                        </span>
                                   </div>
                              ) : preventPurchaseText ? (
                                   <span className="sub-seat text-secondary">{preventPurchaseText}</span>
                              ) : (
                                   <CButton
                                        className={`btn-border btn btn-select-course ${tierSelected ? 'btn-primary' : 'btn-outline-primary'}`}
                                        onClick={() => {
                                             onSelectTeam(productSelected, tier);
                                        }}
                                   >
                                        {tierSelected ? 'SELECTED' : 'SELECT'}
                                   </CButton>
                              )}
                              <span className="price d-flex">
                                   PRICE <strong className="mx-2">${numberWithCommas(tier.price)}</strong> for {tier.seats} Seats
                              </span>
                         </div>
                    );
               })}
          </div>
     );
};

export default SelectTrainingTier;
